import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0003
 */
/**
 * Custom con funciones adicionales al Formulario
 **/
class CustomUsuariosAutorizados extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);


        this.limpiarCampos = this.limpiarCampos.bind(this);
        this.gridOptionsComponentes = Object.assign({}, this.gridOptions);
        this.onSelectionChangedPrincipal                                  = this.onSelectionChangedPrincipal.bind(this);
        this.gridOptionsComponentes['onSelectionChanged']           = this.onSelectionChangedPrincipal;

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerUsuariosAutorizados = this.traerUsuariosAutorizados.bind(this);
        this.sucesstraerUsuarios = this.sucesstraerUsuarios.bind(this);
        this.traerUsuariosSucursal = this.traerUsuariosSucursal.bind(this);
        this.sucesstraerUsuariosSucursal = this.sucesstraerUsuariosSucursal.bind(this);

        
        this.sucessActualizar = this.sucessActualizar.bind(this);
        this.grabarUsuarioAutorizado = this.grabarUsuarioAutorizado.bind(this);

        //imprimir

        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.servicio = '';
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada=[];
        this.array_columnas=[];
        this.tamano_formato=4;
    }

    initForm() {
        console.log('Formulario CustomUsuariosAutorizados,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerUsuariosAutorizados();
        this.getField('nombre_sucursal').setOnChange((props) => {
            this.limpiarCampos();
            if(this.getField('nombre_sucursal').getValue().toString().trim()!=='')
                this.traerUsuariosSucursal();
        });

        this.getField('nombre_usuario1').setOnChange((props) => {
           this.getField('nombre_usuario1').setError(false,'');
        });

        this.getField('nombre_usuario2').setOnChange((props) => {
            this.getField('nombre_usuario2').setError(false,'');
         });
       
 
        this.getField('bt_guardar').setClick(()=>{
            this.grabarUsuarioAutorizado();
        });

        this.getField('bt_cancelar').setClick(()=>{
            this.getField('codigo_sucursal').setValue('');
            this.getField('codigo_sucursal').setError(false,'');
            this.getField('nombre_sucursal').setValue('');
            this.limpiarCampos();
        });


    }


    onSelectionChangedPrincipal(){

    }


    grabarUsuarioAutorizado(){
        if(this.getField('codigo_sucursal').valid() && 
        this.getField('nombre_sucursal').valid() &&
        this.getField('codigo_usuario1').valid() &&
        this.getField('nombre_usuario1').valid() &&
        this.getField('codigo_usuario2').valid() &&
        this.getField('nombre_usuario2').valid()){
                this.mostrarMensajeGuardando();
                let datos={ datos: {
                    sucursal_ingreso:this.sucursal_ingreso,
                    codigo_sucursal :this.getField('codigo_sucursal').getValue(),
                    codigo_usuario1 :this.getField('codigo_usuario1').getValue(),
                    codigo_usuario2 :this.getField('codigo_usuario2').getValue(),
                }};
                this.generalFormatPmv = { tipo_servicio: 'inve-usuariosautorizados', operacion: 'guardar', operacion_tipo: 'crear' };
                this.service.send(
                {
                        endpoint: this.constant.formConfiguration(),
                        method:'POST',
                        body: datos,
                        success: this.sucessActualizar,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                });
        }else{
            this.mostrarMensajeAdicional('Existe un campo vacío o mal configurado.');
        }
    }

    sucessActualizar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){

            this.mostrarMensajeAdicional('Grabado con éxito.');
            this.alertGeneral.toggle(true, 'Operación realizada con éxito.', 'success');
            this.getField('codigo_sucursal').setValue('');
            this.getField('codigo_sucursal').setError(false,'')
            this.getField('nombre_sucursal').setValue('');
            this.limpiarCampos();
            this.traerUsuariosAutorizados();
        }else {
          if(data.estado_p===404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
          }
          else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
          }
        }
      }



    traerUsuariosAutorizados() {
        this.mostrarMensajeGenerando();
        let datos = { datos: {
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-usuariosautorizados', operacion: '1_usuarios', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerUsuarios,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerUsuarios(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            let configCell = new Map();
            this.gridOptionsComponentes['rowData'] = data.data;
            this.getField('rejilla').initData(this.gridOptionsComponentes,configCell);
            this.getField('rejilla').toggle(true);
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerUsuariosSucursal() {
        if(this.getField('codigo_sucursal').valid() && this.getField('nombre_sucursal').valid()){
            this.mostrarMensajeGenerando();
            let datos = { datos: {
                codigo_sucursal:this.getField('codigo_sucursal').getValue(),
            } };
            this.generalFormatPmv = { tipo_servicio: 'inve-usuariosautorizados', operacion: '1_usuarios_sucursal', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.sucesstraerUsuariosSucursal,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
            }
    }

    sucesstraerUsuariosSucursal(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            this.getField('codigo_usuario1').setValue(data.data[0].usuario2);
            this.getField('nombre_usuario1').setValue(data.data[0].nusuario2);
            this.getField('codigo_usuario2').setValue(data.data[0].usuario3);
            this.getField('nombre_usuario2').setValue(data.data[0].nusuario3);
        } else if (data.estado_p === 404) {
            //this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    limpiarCampos() {
        this.getField('nombre_sucursal').setError(false,'');
        this.getField('codigo_usuario1').setError(false,'');
        this.getField('nombre_usuario1').setError(false,'');
        this.getField('codigo_usuario2').setError(false,'');
        this.getField('nombre_usuario2').setError(false,'');

        this.getField('codigo_usuario1').setValue('');
        this.getField('nombre_usuario1').setValue('');
        this.getField('codigo_usuario2').setValue('');
        this.getField('nombre_usuario2').setValue('');
        //this.getField('rejilla').toggle(false);
    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


}
FormJaivana.addController("inve-usuariosautorizados", CustomUsuariosAutorizados);
export default CustomUsuariosAutorizados